import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import ManagePayments from '../Profile/ManagePayments'

const ManagePaymentsPage = () => {
  return (
    <>
        <Header/>
        <ManagePayments/>
        <Footer/>
    </>
  )
}

export default ManagePaymentsPage